var map = {
	"./1.1.png": 2891,
	"./1.2.png": 3040,
	"./1.jpg": 8352,
	"./1.png": 7508,
	"./10.1.png": 5121,
	"./10.png": 4302,
	"./11.1.png": 5044,
	"./12.1.png": 2515,
	"./13.1.png": 6758,
	"./14.1.png": 4853,
	"./15.1.png": 3704,
	"./16.1.png": 6007,
	"./17.1.png": 9450,
	"./18.1.png": 921,
	"./19.1.png": 1068,
	"./2.1.png": 8956,
	"./2.2.png": 5991,
	"./2.jpg": 3311,
	"./2.png": 6415,
	"./20.1.png": 8620,
	"./21.1.png": 8505,
	"./22.1.png": 5886,
	"./23.1.png": 7931,
	"./24.1.png": 4448,
	"./25.1.png": 8525,
	"./26.1.png": 530,
	"./3.1.png": 8809,
	"./3.2.png": 7842,
	"./3.jpg": 3314,
	"./3.png": 7398,
	"./4.1.png": 9698,
	"./4.2.png": 5785,
	"./4.jpg": 9873,
	"./4.png": 473,
	"./5.1.png": 431,
	"./5.jpg": 1348,
	"./5.png": 3568,
	"./6.1.png": 8224,
	"./6.jpg": 3155,
	"./6.png": 3419,
	"./7.1.png": 333,
	"./7.jpg": 8454,
	"./7.png": 2290,
	"./8.1.png": 4646,
	"./8.png": 9237,
	"./9.1.png": 403,
	"./9.png": 9820,
	"./author.png": 6704,
	"./author2.png": 2880,
	"./author3.png": 7081,
	"./author4.png": 7110,
	"./author5.png": 911,
	"./beg.png": 9799,
	"./course-banner1.jpg": 2342,
	"./course-banner2.jpg": 9041,
	"./course-banner3.jpg": 4644,
	"./small-image/1.png": 5084,
	"./small-image/2.png": 9015,
	"./small-image/3.png": 9518,
	"./small-image/4.png": 8001,
	"./small-image/5.png": 6872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1469;